import { RouteConfig } from 'vue-router';
const CepingReport = () => import('./views/ceping-report.vue');
const routers: RouteConfig[] = [
    {
        path: 'ceping-report',
        name: 'ceping-report',
        component: CepingReport
    },
    {
        path: '*',
        redirect: 'ceping-report'
    },
];
export default routers;

